import devHelper from '../../util/devHelper'
import dbHelper from '../../util/db'
import debugHelper from '../../util/debug'
import common from './common'
import { resetState } from '../../store'
import msgbus from '../../msgBus'
import functions from '@/functions'


var login = {
  // 根据tid，读取key
  funcGetKeyBaseTid(tid) {
    let tentans = msgbus.vm.getAccountTenants()
    let tentanKey = ''
    tentans.forEach(tenant => {
      if (tenant.id === tid) {
        tentanKey = tenant.mobileAppLicense.entKey.key
      }
    })
    return tentanKey
  },

  // 根据tid，读取tname
  funcGetTnameBaseTid(tid) {
    let tentans = msgbus.vm.getAccountTenants()
    let tname = ''
    tentans.forEach(tenant => {
      if (tenant.id === tid) {
        tname = tenant.name
      }
    })
    return tname
  },

  // 根据key，读取tid
  funcGetTidBaseKey(key) {
    let tentans = msgbus.vm.getAccountTenants()
    let tid = ''
    tentans.forEach(tenant => {
      // 判断是否开启了测试模式，若是，执行测试代码
      if (devHelper.isDevMode()) {
        alert('tenant.mobileAppLicense.entKey.key:' + tenant.mobileAppLicense.entKey.key + ' 插件返回key:' + key)
      }
      if (tenant.mobileAppLicense.entKey.key === key) {
        tid = tenant.id
      }
    })
    return tid
  },

  // 根据tid,读取用户OID
  funcGetUserOIDBaseTid(tid) {
    let tentans = msgbus.vm.getAccountTenants()
    let userOID = ''
    tentans.forEach(tenant => {
      if (tenant.id === tid) {
        userOID = tenant.user.fid
      }
    })
    return userOID
  },

  /**
   * 刷新用户Token
   * @param {*} vm
   * @param {*} funcList
   */
  funcRefreshToken: function (vm, funcList) {
    debugHelper.log('funcRefreshToken: 刷新用户Token')
    console.log('调试代码 funcRefreshToken: 刷新用户Token')

    vm.refreshAuthToken({
      vm: vm,
      authorization: {
        Authorization: 'Bearer ' + dbHelper.get('token')
      }
    }).then(
      () => {
        common.callNextFunc(vm, funcList)
      },
      () => {
        return
      }
    )
  },

  /**
   * 获取用户信息
   * @param {*} vm
   * @param {*} funcList
   */
  funcFetchUserInfo: function (vm, funcList) {
    funcList = funcList[0].setParams(funcList)
    if (vm == null) {
      return
    }

    debugHelper.log('funcFetchUserInfo: 获取用户信息')

    if (vm.getCurrentTenantID() == '') {
      // 没有租户
      vm.setSnackBar({
        value: {
          color: 'error',
          text: this.$t('当前账号不属于任何租户，租户信息可能正在审核中，请等待!'),
          visible: true,
        },
      })
      // 跳转登录页面
      if (vm.$route.name !== 'pwdlogin') {
        vm.$router.replace({ name: 'pwdlogin' })
      }
    } else {
      vm.fetchUserInfo({
        tid: vm.getCurrentTenantID(),
        vm: vm,
        authorization: {
          Authorization: 'Bearer ' + vm.getAccountToken()
        }
      }).then(() => {
        funcList[0].getResult(funcList)
        common.callNextFunc(vm, funcList)
      })
    }
  },

  funcLogout: function (vm, funcList) {
    funcList = funcList[0].setParams(funcList)

    var params = funcList[0].params
    vm.setBottomNavVisible(false)

    // 清除定时器
    clearInterval(vm.getTimer())

    // 清空localstorage里用户相关的数据，包含清token
    dbHelper.restore()

    // 重置state
    resetState()
    vm.setPlatform(window.device.platform)
    functions.versionCheckHelper.funcGetAppDispVersion()

    // 跳转登录页面
    vm.$router.replace({ name: 'pwdlogin' })
    common.callNextFunc(vm, funcList)
  }
}

export default login
